export default "__VITE_ASSET__BJ60Jgl7__"